import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Tooltip } from 'antd';
import NumberFormat from 'react-number-format';
import { RangePicker } from '../../../components/FormFields';
import moment from 'moment';
import './styles.scss';
import { getLocalStorageData } from '../helpers';
import { Radio } from 'antd';
import { identity } from '../../../../utils/getIdentity';
import { useTranslation } from "react-i18next";


const TableData = ({
  title,
  drawData,
  propName,
  action,
  type = 'users',
  redirectTo,
  countItems,
  prefix,
  typeNetwork,
  sharedDate,
  setSharedDate,
  setChangedFieldsArray,
  changedFieldsArray,
  changeAllDataPickers,
  onChangeHandler,
  datesForAllExceptUsers,
  permissions
}) => {
  const [selectedData, setSelectedData] = useState(() => getLocalStorageData(type));
  const [pickerOpened, setPickerOpened] = useState(false);
  const history = useHistory();
  const { data } = drawData;
  const { total, statistics } = data || {};

  const savedDate = getLocalStorageData(type);

  const { t } = useTranslation();

  const handler = e => {
    if (type === 'users') {
      if (changeAllDataPickers) {
        setSharedDate(e);
        setChangedFieldsArray([]);
        localStorage.setItem(
          `adm-date-all`,
          JSON.stringify([e[0].format('YYYY-MM-DD') + 'T00:00:01', e[1].format('YYYY-MM-DD') + 'T23:59:59'])
        );
        return;
      }
    }
    localStorage.setItem(
      `adm-date-${type}`,
      JSON.stringify([e[0].format('YYYY-MM-DD') + 'T00:00:01', e[1].format('YYYY-MM-DD') + 'T23:59:59'])
    );

    setSelectedData(e);
    setChangedFieldsArray(prev => [...prev, type]);
  };

  useEffect(() => {
    selectedData && permissions && permissions[0]?.view &&
      action({
        dateFrom: selectedData[0]?.format('YYYY-MM-DD') + 'T00:00:01',
        dateTo: selectedData[1]?.format('YYYY-MM-DD') + 'T23:59:59',
        type: type === 'users' ? undefined : type,
        typeNetwork: typeNetwork,
      });
  }, [selectedData, typeNetwork, permissions]);

  useEffect(() => {
    sharedDate && permissions && permissions[0]?.view &&
      action({
        dateFrom: sharedDate[0]?.format('YYYY-MM-DD') + 'T00:00:01',
        dateTo: sharedDate[1]?.format('YYYY-MM-DD') + 'T23:59:59',
        type: type === 'users' ? undefined : type,
        typeNetwork: typeNetwork,
      });
  }, [sharedDate, typeNetwork, permissions]);

  useEffect(() => {
    type !== 'users' &&
      !changedFieldsArray.includes(type) &&
      datesForAllExceptUsers && permissions && permissions[0]?.view &&
      action({
        dateFrom: datesForAllExceptUsers[0]?.format('YYYY-MM-DD') + 'T00:00:01',
        dateTo: datesForAllExceptUsers[1]?.format('YYYY-MM-DD') + 'T23:59:59',
        type: type === 'users' ? undefined : type,
        typeNetwork: typeNetwork,
      });
  }, [datesForAllExceptUsers, type, typeNetwork, permissions]);

  useEffect(() => {
    const key = `adm-date-${type}`;

    if (type === 'users') return;

    if (changeAllDataPickers && localStorage.getItem(`adm-date-${type}`)) {
      return localStorage.removeItem(key);
    }
  }, [changeAllDataPickers]);

  return (
    <div className="dashboard-table-data">
      <div className={`dashboard-table-data__header dashboard-table-data__header-${identity}`}>
        <h2 className={`dashboard-table-data__title dashboard-table-data__title-${identity}`}>{title}</h2>

        {type === 'users' ? (
          <div className="admin-dashboard-container-radio-button">
            <p>{t('admin.apply_dates')}</p>
            <Radio.Group onChange={onChangeHandler} value={changeAllDataPickers}>
              <Radio value={true}>{t('admin.all_tables')}</Radio>
              <Radio value={false}>{t('admin.users_only')}</Radio>
            </Radio.Group>
          </div>
        ) : null}
        <RangePicker
          onBlur={() => {
            pickerOpened && setPickerOpened(false);
          }}
          bordered={false}
          allowEmpty={false}
          allowClear={false}
          withInitial={true}
          onFocus={() => {
            !pickerOpened && setPickerOpened(true);
          }}
          open={pickerOpened}
          format="DD.MM.YYYY"
          onChange={e => handler(e)}
          defaultValue={savedDate ? savedDate : [moment().startOf('month'), moment().endOf('month')]}
          value={
            changedFieldsArray.includes(type)
              ? selectedData
              : type === 'users' || changeAllDataPickers
              ? sharedDate
              : datesForAllExceptUsers
          }
          // value={
          //   sharedDate && !changedFieldsArray.includes(type)
          //     ? sharedDate
          //     : datesForAllExceptUsers && type !== 'users'
          //     ? datesForAllExceptUsers
          //     : selectedData
          // }
          ranges={{
            [t('admin.today')]: [moment(), moment()],
            [t('admin.this_week')]: [moment().startOf('week'), moment().endOf('week')],
            [t('admin.this_month')]: [moment().startOf('month'), moment().endOf('month')],
            [t('admin.this_year')]: [moment().startOf('year'), moment().endOf('year')],
            [t('admin.last_week')]: [moment().subtract(1, 'week').startOf('week'), moment().subtract(1, 'week').endOf('week')],
            [t('admin.last_month')]: [
              moment().subtract(1, 'month').startOf('month'),
              moment().subtract(1, 'month').endOf('month'),
            ],
            [t('admin.last_year')]: [moment().subtract(1, 'year').startOf('year'), moment().subtract(1, 'year').endOf('year')],
          }}
        />
      </div>
      <div className={`dashboard-table-data__table-content dashboard-table-data__table-content-${identity}`}>
        <table className={`dashboard-table-data__table ${type === 'users' ? 'users' : null}`}>
          <tbody>
            <tr>
              <th>{t('admin.data')}</th>
              {statistics &&
                statistics.map(el =>
                  type === 'users' ? (
                    <Tooltip title={'Click to show'} placement="top" key={`${el.time}-${el.amount}`}>
                      <td
                        key={`${el.time}-${el.amount}`}
                        onClick={() =>
                          redirectTo && history.push(`${redirectTo}?from=${el.timeStamp.from}&to=${el.timeStamp.to}`)
                        }
                      >
                        {el.time}
                      </td>
                    </Tooltip>
                  ) : (
                    <td
                      key={`${el.time}-${el.amount}`}
                      onClick={() =>
                        redirectTo && history.push(`${redirectTo}?from=${el.timeStamp.from}&to=${el.timeStamp.to}`)
                      }
                    >
                      {el.time}
                    </td>
                  )
                )}
            </tr>
            <tr>
              <th>{propName}</th>
              {statistics &&
                statistics.map((el, index) => (
                  <td key={index}>
                    <NumberFormat
                      value={el.count || el.amount || 0}
                      displayType={'text'}
                      thousandSeparator={' '}
                      decimalScale={2}
                      prefix={prefix}
                    />
                  </td>
                ))}
            </tr>
          </tbody>
        </table>
        <div className="dashboard-table-data__total">
          <div className="dashboard-table-data__total-title">{t('admin.total')}</div>
          <NumberFormat
            value={total || 0}
            displayType={'text'}
            thousandSeparator={' '}
            className={`dashboard-table-data__total-count dashboard-table-data__total-count-${identity}`}
            prefix={prefix}
            decimalScale={2}
          />
        </div>
      </div>
      {countItems ? <div className={`dashboard-table-data__info dashboard-table-data__info-${identity}`}>{countItems} {t('admin.all_time')}</div> : null}
    </div>
  );
};

export default TableData;